import { Handle, Position } from 'reactflow';

/**
 * Uma saída nomeada do bloco, com o ponto de conexão alinhado à própria linha.
 *
 * Antes os blocos de duas saídas punham uma à direita com `top: '35%'` e a
 * outra embaixo: o percentual era chutado para a altura antiga do cartão, e
 * qualquer mudança de conteúdo desalinhava o ponto do rótulo que ele
 * representa — dá para ligar o "Não" achando que se está ligando o "Sim".
 *
 * Aqui o ponto mora dentro da linha, então fica sempre onde o rótulo está.
 * O `id` é o que o motor lê para escolher o caminho: mudá-lo quebraria as
 * ligações de fluxos já salvos.
 */
export function SaidaNomeada({
  id,
  rotulo,
  cor,
}: {
  id: string;
  rotulo: string;
  /** 'verde' | 'vermelho' | 'neutro' */
  cor: 'verde' | 'vermelho' | 'neutro';
}) {
  const estilo = {
    verde: { texto: 'text-emerald-700', ponto: 'bg-emerald-500', handle: '!bg-emerald-400 !border-emerald-500' },
    vermelho: { texto: 'text-rose-700', ponto: 'bg-rose-500', handle: '!bg-rose-400 !border-rose-500' },
    neutro: { texto: 'text-foreground/70', ponto: 'bg-gray-400', handle: '!bg-gray-300 !border-gray-400' },
  }[cor];

  return (
    <div className="relative flex items-center gap-1.5 py-0.5">
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${estilo.ponto}`} />
      <span className={`flex-1 text-[11px] truncate ${estilo.texto}`}>{rotulo}</span>
      <Handle
        type="source"
        position={Position.Right}
        id={id}
        aria-label={`Saída: ${rotulo}`}
        className={`!w-2.5 !h-2.5 !relative !top-0 !right-0 !translate-x-[50%] !translate-y-0 !ml-1 ${estilo.handle}`}
      />
    </div>
  );
}
